import { Feature, feature, Geometries } from "@turf/helpers";
import { SelectionFeature, SelectionGeometry, SelectionType } from "src/js/stores/map/store";
import { designationIsAssessable } from "react-migration/layouts/map/Multilayer/layer_types/ConstraintsLayerType/constraintClickResolver/designationIsAssessable";
import { DesignationFeature } from "../../components/ConstraintLayer/DesignationLayer";
import { designationGeometryByIdQuery } from "../hooks/useDesignationGeometryById";

async function getSelectionGeometry(
  designation: DesignationFeature,
  isAssessable: boolean,
  combineGeometries: (geometries: Geometries[]) => Feature<Geometries>
): Promise<SelectionGeometry | null> {
  if (!isAssessable) {
    return null;
  }

  const { data } = await designationGeometryByIdQuery(designation.properties.designation_id);
  const geometries = data.designation.designation_geometries.map(({ geometry }) => geometry);
  const geometry = geometries && combineGeometries(geometries).geometry;

  return geometry;
}

export async function createDesignationSelection(
  designation: DesignationFeature,
  combineGeometries: (geometries: Geometries[]) => Feature<Geometries>,
  selectionType: SelectionType = SelectionType.DESIGNATION
): Promise<SelectionFeature | null> {
  const isAssessable = designationIsAssessable(designation);
  const geometry = await getSelectionGeometry(designation, isAssessable, combineGeometries);

  return {
    type: selectionType,
    id: designation.properties.designation_id,
    feature: geometry ? feature(geometry, designation.properties) : undefined,
    hideAssessment: !isAssessable,
    savable: isAssessable,
  };
}
